import { clearBookingsFromLocalStorage } from "../../Utilities/general";
import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGIN_REQUEST,
  LOGOUT,
} from "../constants/LoginConstants";
import {
  GET_USER_PROFILE_FAIL,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_REQUEST,
} from "../constants/userProfileConstants";

// used for post content
export const loginReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loginInfo: null,
        token: null,
        loginLoading: true,
      };
    case LOGIN_SUCCESS:
      // Backwards compatible payload shapes:
      // - legacy: payload is the user profile object
      // - new: payload is { loginInfo, token }
      const loginInfo = payload?.loginInfo ?? payload?.user ?? payload;
      const token = payload?.token ?? null;
      try {
        if (loginInfo) {
          localStorage.setItem("wemoovezUserProfile", JSON.stringify(loginInfo));
        }
        if (token) {
          localStorage.setItem("token", String(token));
        }
      } catch (e) {
        // ignore storage errors
      }
      return {
        ...state,
        loginLoading: false,
        loginInfo,
        token,
        loginError: "",
      };
    case LOGIN_FAIL:
      console.log("error is here", payload);
      return {
        ...state,
        loginLoading: false,
        loginError: payload,
      };
    case LOGOUT:
      try {
        localStorage.removeItem("wemoovezUserProfile");
        localStorage.removeItem("token");
      } catch (e) {
        // ignore
      }
      clearBookingsFromLocalStorage();
      return {
        ...state,
        loginInfo: null,
        token: null,
        loginLoading: false,
        loginError: null,
      };
    case GET_USER_PROFILE_REQUEST:
      return {
        ...state,
        loginInfo: null,
        userProfileLoading: true,
      };
    case GET_USER_PROFILE_SUCCESS:
      try {
        localStorage.setItem("wemoovezUserProfile", JSON.stringify(payload));
      } catch (e) {
        // ignore
      }
      return {
        ...state,
        userProfileLoading: false,
        loginInfo: payload,
        userProfileError: "",
      };
    case GET_USER_PROFILE_FAIL:
      return {
        ...state,
        userProfileLoading: false,
        userProfileError: payload,
      };
    default:
      return state;
  }
};
